import { useState } from 'react'

/* How to use:
 * import useDebounce from 'hooks/debounce'
 * const debounceAction = useDebounce((value) => console.log(value))
*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebounce = <A extends any[]>(debouncedCallback: (...parameters: A) => void, timeout = 1000) => {
  const [timer, setTimer] = useState<NodeJS.Timeout>()

  return (...parameters: A) => {
    if (timer) {
      clearTimeout(timer)
    }

    setTimer(setTimeout(() => debouncedCallback(...parameters), timeout))
  }
}

export default useDebounce
